import { Component, OnInit, NgModule } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormsModule, FormArray } from '@angular/forms';
import { CrudService } from './../../../crud/crud.service';
import { Router } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { createAutoCorrectedDatePipe } from 'text-mask-addons';

import { Mensaje } from '../../../mensaje';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import * as moment from 'moment';


@Component({
  selector: 'app-alumno-matricula-formulario',
  templateUrl: './matricula.component.html'
})

export class MatriculaComponent implements OnInit {
  dato: FormGroup;
  periodo_escolar;

  // Mensaje
  titulo; mensaje; clase;

  grupo;
  carrera_plan;
  cargarDatosCatalogo = false;

  constructor(private route: ActivatedRoute, private router: Router, public fb: FormBuilder, private crud: CrudService, private notificacion: NotificationsService) { }

  ngOnInit() {
    this.dato = this.fb.group({
      id: [''],
      periodos_escolares_id: ['', [Validators.required]],
      grupos_id: ['', [Validators.required]],
      grupos: this.fb.array([]),
    });

    //Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();
  }


  detalleGrupo(periodo, grupo_id) {
    //console.log(item);
    this.cargarDatosCatalogo = true;
    this.crud.ver(grupo_id, "grupo").subscribe(resultado => {
      this.cargarDatosCatalogo = false;
      this.grupo = resultado.data;
      this.carrera_plan = resultado.data.carreras_planes;
      //this.dato.controls.periodos_escolares_id.patchValue(periodo);
      //this.dato.controls.grupos_id.patchValue(grupo_id);
      this.dato.controls.grupos = this.fb.array([]);
      resultado.data.grupos_alumnos.forEach(element => {

        const grupo = <FormArray>this.dato.controls.grupos;
        // SE DEBE CAMBIAR EL CAMPO matricula A LA TABLA PERSONAS
        if(element.alumnos.baja == 0)
        {
        grupo.controls.push(
          this.fb.group(
            {
              personas_id: [element.alumnos.id, [Validators.required]],
              //nombre: [element.alumnos.alumnos_metadatos.apellido_paterno + ' ' + element.alumnos.alumnos_metadatos.apellido_materno + ' ' + element.alumnos.alumnos_metadatos.nombre],
              nombre: [element.alumnos.apellido_paterno + ' ' + element.alumnos.apellido_materno + ' ' + element.alumnos.nombre],
              matricula: [element.alumnos.matricula],
              folio_certificado: [element.alumnos.folio_certificado]
            }
          )
        )
      }

      });
    },
      error => {
        this.cargarDatosCatalogo = false;
        this.titulo = "Sin resultados";
        this.mensaje = "No se encontro datos";
        this.clase = "warning";
        document.getElementById("message").click();
      }
    )
  }
  // detalleGrupo(event, periodo) {

  //   let id = null;
  //   if(event){
  //     if (event.hasOwnProperty("value")) {
  //       id = event.value;
  //     }else{
  //       id = event;
  //     }
  //   }

  //   if (id != "") {
  //     this.cargarDatosCatalogo = true;
  //     this.crud.ver(id, "grupo").subscribe(resultado => {
  //       console.log(resultado);

  //       this.cargarDatosCatalogo = false;
  //       this.grupo = resultado.data;
  //       this.carrera_plan = resultado.data.carreras_planes;

  //       this.dato.controls.periodos_escolares_id.patchValue(periodo);
  //       this.dato.controls.grupos_id.patchValue(id);
  //       this.dato.controls.grupos = this.fb.array([]);
  //       resultado.data.grupos_alumnos.forEach(element => {

  //         const grupo = <FormArray>this.dato.controls.grupos;
  //         // SE DEBE CAMBIAR EL CAMPO matricula A LA TABLA PERSONAS
  //         grupo.controls.push(
  //           this.fb.group(
  //             {
  //               personas_id: [element.alumnos.id, [Validators.required]],
  //               nombre: [element.alumnos.alumnos_metadatos.apellido_paterno + ' ' + element.alumnos.alumnos_metadatos.apellido_materno + ' ' + element.alumnos.alumnos_metadatos.nombre],
  //               matricula: [element.alumnos.matricula],
  //               folio_certificado: [element.alumnos.folio_certificado]
  //             }
  //           )
  //         )
  //       });
  //     },
  //       error => {
  //         this.cargarDatosCatalogo = false;
  //         this.titulo = "Sin resultados";
  //         this.mensaje = "No se encontro datos";
  //         this.clase = "warning";
  //         document.getElementById("message").click();
  //       }
  //     );
  //   }
  // }

  mandar() {
    let dato = this.dato.getRawValue();
    console.log(dato);

  }
}
